<template>
  <!-- eslint-disable-next-line vue/no-v-html -->
  <div v-html="svg" />
</template>

<script>
export default {
  name: 'VcSvg',
  // eslint-disable-next-line vue/require-prop-types
  props: ['svg'],
};
</script>
